import {Component, Input, ViewChild} from '@angular/core';
import {PopoverDirective} from 'ngx-bootstrap';

/**
 * Rc popover component - render content and open another content in popover on click.
 * Currently uses ngx-bootstrap popover
 *
 * @example
 * <lib-rc-popover [trigger]="click" [placement]="bottom">
 *  <div popoverOpener>I am the opener</div>
 *  <div popoverContent>Some content, can be another component</div>
 * </lib-rc-popover>
 */
@Component({
    selector: 'lib-rc-popover',
    template: `<button #pop="bs-popover"
        [popover]="popoverContent"
        triggers="{{trigger}}"
        [outsideClick]="outsideClick"
        placement="{{placement}}"
        [attr.aria-expanded]="isOpen"
>
    <ng-content select="[popoverOpener]"></ng-content>
</button>

<ng-template #popoverContent>
    <ng-content select="[popoverContent]"></ng-content>
</ng-template>


`,
    styles: [``]
})
export class RcPopoverComponent {

    /**
     * Popover trigger
     */
    @Input() trigger: string = 'click';

    /**
     * Set if click out side will close the popover
     */
    @Input() outsideClick: boolean = true;

    /**
     * Set popover location (top, bottom, left, right)
     */
    @Input() placement: string = 'bottom';

    @ViewChild(PopoverDirective) pop: PopoverDirective;

    constructor() {

    }

    get isOpen() {
        return this.pop.isOpen;
    }

    hide() {
        this.pop.hide();
    }
}
